import { get } from 'lodash';
import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

import { UniversalDataExportEnum } from 'Common/FieldEnum';
import {
  makeOptionsData,
  makeOptionsDataWithEmpty,
  numericSort,
} from 'Common/FormHelper';
import { createMap } from 'Common/Helpers/format';
import { UNIVERSAL_DATA_EXPORT_FORM_NAME } from 'Common/FormEnum';
import { DEFAULT_GROUP_ID } from 'Pages/universaldataexport/helpers/constants';

const root = state => get(state, 'UniversalDataExportState');

export const getFetching = state => get(root(state), 'fetching');
export const getFetchError = state => get(root(state), 'fetchError', null);
export const formValuesSelector = getFormValues(
  UNIVERSAL_DATA_EXPORT_FORM_NAME
);
export const getUniversalDataExportFormValues = state =>
  formValuesSelector(state) || {};

// groups
export const getGroups = state => get(root(state), 'groups', []);
export const getGroupOptions = createSelector(getGroups, groups =>
  makeOptionsData(groups, undefined, numericSort)
);
export const getSelectedGroupId = state => {
  const formValues = formValuesSelector(state);
  return formValues
    ? formValues[UniversalDataExportEnum.GroupId]
    : DEFAULT_GROUP_ID;
};

// fields
export const getFields = state => get(root(state), 'fields', []);
export const getFieldsByGroupId = createSelector(
  getFields,
  getSelectedGroupId,
  (fields, groupId) =>
    fields.filter(f => f[UniversalDataExportEnum.GroupId] === groupId)
);

// configs
export const getConfigs = state => get(root(state), 'configs', []);
export const getConfigsMap = createSelector(getConfigs, configs =>
  createMap(configs)
);
export const getConfigOptions = createSelector(getConfigs, configs =>
  makeOptionsDataWithEmpty(configs)
);



// WEBPACK FOOTER //
// ./src/pages/universaldataexport/state/selectors.js